module.exports = [{"slNo":0,"ageName":"0 Years"},{"slNo":1,"ageName":"1 Years"},{"slNo":2,"ageName":"2 Years"},{"slNo":3,"ageName":"3 Years"},{"slNo":4,"ageName":"4 Years"},{"slNo":5,"ageName":"5 Years"},{"slNo":6,"ageName":"6 Years"},{"slNo":7,"ageName":"7 Years"},{"slNo":8,"ageName":"8 Years"},{"slNo":9,"ageName":"9 Years"},{"slNo":10,"ageName":"10 Years"},{"slNo":11,"ageName":"11 Years"},{"slNo":12,"ageName":"12 Years"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/ageMapping.json
// module id = 877
// module chunks = 0